<script>
import { Pie } from 'vue-chartjs';
import { COLORS_PALETTE_2 } from '../../util/chart-constants';

export default {
	extends: Pie,
	name: 'PieChart',
	props: {
		chart: {
			default: function() {
				return [];
			}
		}, 
		data: {},
		labels: {},
		options: {},
		colorPalette: {}
	},
	methods: {
		adjustAndRender: function() {
			var labels = this.labels || this.chart.labels,
				data = this.data || this.chart.data,
				options = this.options || this.chart.options;
		
			var chartData = {
				labels: labels,
				datasets: [
					{ 
						data,
						backgroundColor: this.colorPalette != null ? this.colorPalette : COLORS_PALETTE_2
					}
				]
			};
			var chartOptions = {
				legend: {
					display: true,
					position: 'top'
				},
				animation: {
					duration: 0
				}
			};
			
			this.renderChart(chartData, Object.assign(chartOptions, options));
		}
	},
	watch: { 
		chart: function() {
			this.adjustAndRender();
		}
	},
	mounted() {
		this.adjustAndRender();
	}
}
</script>